import React from 'react';
export  var FacilitiesHeader = React.createClass({

    render() {

        return (

            <div className="row">
            <div className="col-xs-4 no-padding">
              <div className="input-group dashboard-search"><span className="input-group-addon"><span className="icon-search"></span></span><input type="text" onKeyUp={this.props.searchlist} className="inputText" required/><span className="floating-label">Search</span></div>
            </div>
               <div className="col-xs-8 list-grid-holder pull-right no-padding">
                  <ul id={this.props.activeTgCls+"-active"} className="pull-right">
                      <li> <button id="grid-view"  onClick={this.props.tgGrid}><span className="icon icon-grid"></span></button></li>
                     <li> <button id="list-view" onClick={this.props.tgList}><span className=" icon icon-list"></span></button></li>
                     <li>
                           <button className="add-facility-button gray-button" onClick={this.props.addnew}>+ Add Clinic</button>
                     </li>
                  </ul>
               </div>
            </div>
        );
    }
});
// <div className="input-group dashboard-search"><span className="input-group-addon"><span className="icon-search"></span></span><input type="text" onChange={this.props.searchlist} className="inputText" required/><span className="floating-label">Search</span></div>



/** WEBPACK FOOTER **
 ** ./src/components/facilitiesScreen/facility-header.js
 **/